import {
  ClockIcon,
  LightBulbIcon,
  MagnifyingGlassIcon,
  LifebuoyIcon,
} from '@heroicons/react/24/outline';
import React from 'react';
import { Redirect, useHistory, useRouteMatch } from 'react-router-dom';
import DashboardNav from '../components/dashboard-nav/DashboardNav';
import { useBriefsOverview } from '../hooks/useBriefs';
import DashboardPageLayout from '../layouts/dashboard/dashboardPageLayout';

const newslitFeatures = [
  {
    id: 1,
    name: 'Save Time',
    description:
      'We do the research for you! You get a real-time dashboard and a daily news briefs via e-mail or Slack to ensure you never miss a thing.',
    icon: ClockIcon,
  },
  {
    id: 2,
    name: 'Cut the noise ',
    description:
      'We spot signals hidden to 90% of the world by tracking well over 100,000 news sources and integrating social signals from thousands of top business influencers.',
    icon: MagnifyingGlassIcon,
  },
  {
    id: 3,
    name: 'Stay ahead',
    description:
      'It’s easy to miss important stories. With Newslit, you can connect with over 2,000 applications via Zapier to create workflows and keep track of everything.',
    icon: LightBulbIcon,
  },
  {
    id: 4,
    name: 'Sit back and relax',
    description:
      'Newslit is working 24/7 so you can rest at ease. Did we mention? once is set up, is 100% automated.',
    icon: LifebuoyIcon,
  },
];

export default function DashboardPage() {
  const history = useHistory();
  const match = useRouteMatch();

  const { briefs: briefItems } = useBriefsOverview();
  const briefs = { items: briefItems };

  const handleAddNewBriefClick = () => {
    history.push(`${match.url}?brief=new`);
  };

  if (briefs && briefs.items && briefs.items.length > 0) {
    return <Redirect to={`/dashboard/brief/${briefs.items[0].id}`} />;
  }

  return (
    <DashboardPageLayout title="Newslit Dashboard">
      {/* main area */}
      <main className="flex flex-1 z-0 overflow-y-auto overflow-hidden bg-white focus:outline-hidden">
        {/* Primary section */}
        <section className="flex-1 h-full relative flex flex-col">
          {/* Brief Navbar */}
          <div className="shrink-0 z-20">
            <div className="h-12 sm:hidden"></div>
            <div className="fixed z-10 top-0 right-0 w-full sm:relative sm:top-auto sm:right-auto">
              <DashboardNav className="md:hidden">
                <div className="flex-1 flex">
                  <h1 className="text-lg font-bold m-0 text-gray-900">Newslit News</h1>
                </div>
              </DashboardNav>
            </div>
          </div>

          <div className="block sm:flex sm:h-full sm:overflow-y-auto">
            <div className="py-8 sm:py-16 lg:py-24">
              <div className="relative max-w-xl mx-auto px-4 sm:px-6 lg:px-8 lg:max-w-7xl">
                <div className="relative">
                  <h2 className="text-center text-2xl sm:text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                    <span className="block">Be the first to know your</span>
                    <span className="block text-secondary">industry's trending news</span>
                  </h2>
                  <p className="mt-4 max-w-2xl mx-auto text-center text-xl text-gray-600">
                    We know you’re busy! After a quick setup, you’ll have a personalized news brief
                    packed with content to hone in on your <strong>industry</strong>,{' '}
                    <strong>competitors</strong> and <strong>brands</strong> that delivers you an
                    unparalleled knowledge advantage.
                  </p>
                  <div className="mt-4 text-center">
                    <button
                      type="button"
                      className="inline-flex items-center px-6 py-3 border border-transparent shadow-xs text-base font-bold rounded-md text-white bg-secondary hover:bg-secondary-dark hover:text-white hover:no-underline focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-secondary"
                      onClick={handleAddNewBriefClick}
                    >
                      Add your first New Brief
                    </button>
                  </div>
                </div>

                <div className="mt-10">
                  <dl className="space-y-10 md:space-y-0 md:grid md:grid-cols-2 md:gap-x-8 md:gap-y-10">
                    {newslitFeatures.map(feature => (
                      <div key={feature.name} className="relative">
                        <dt>
                          <div className="absolute flex items-center justify-center h-12 w-12 rounded-md bg-secondary-dark text-white">
                            <feature.icon className="h-6 w-6" aria-hidden="true" />
                          </div>
                          <p className="ml-16 text-lg leading-6 font-medium text-gray-900">
                            {feature.name}
                          </p>
                        </dt>
                        <dd className="mt-2 ml-16 text-base text-gray-500">
                          {feature.description}
                        </dd>
                      </div>
                    ))}
                  </dl>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </DashboardPageLayout>
  );
}
